import styled from '@emotion/styled';

const TextButton = styled.button(({ theme }) => ({
    textDecoration: 'underline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.guinea,
}));

export default TextButton;
